var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 14.1014V16.6014C18.3341 16.8335 18.2866 17.0632 18.1936 17.2758C18.1006 17.4885 17.9643 17.6794 17.7933 17.8363C17.6222 17.9932 17.4203 18.1126 17.2005 18.187C16.9806 18.2613 16.7477 18.2889 16.5165 18.268C13.9522 17.9894 11.489 17.1132 9.32486 15.7097C7.31139 14.4303 5.60431 12.7232 4.32486 10.7097C2.91651 8.53572 2.04007 6.06054 1.76653 3.48472C1.7457 3.25427 1.77309 3.02202 1.84695 2.80274C1.9208 2.58346 2.03951 2.38196 2.1955 2.21107C2.3515 2.04018 2.54137 1.90364 2.75302 1.81015C2.96468 1.71666 3.19348 1.66827 3.42486 1.66805H5.92486C6.32928 1.66407 6.72136 1.80728 7.028 2.07099C7.33464 2.33471 7.53493 2.70092 7.59153 3.10138C7.69705 3.90144 7.89274 4.68699 8.17486 5.44305C8.28698 5.74132 8.31125 6.06548 8.24478 6.37712C8.17832 6.68875 8.02392 6.97481 7.79986 7.20138L6.74153 8.25972C7.92783 10.346 9.65524 12.0734 11.7415 13.2597L12.7999 12.2014C13.0264 11.9773 13.3125 11.8229 13.6241 11.7565C13.9358 11.69 14.2599 11.7143 14.5582 11.8264C15.3143 12.1085 16.0998 12.3042 16.8999 12.4097C17.3047 12.4668 17.6744 12.6707 17.9386 12.9826C18.2029 13.2945 18.3433 13.6927 18.3332 14.1014Z",
    stroke: "#191F28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.fbc5917c64ada9a3e8fde28e72507c52.svg";
export { ForwardRef as ReactComponent };